import type { FunctionComponent } from "react";
import { IconButton } from "@similarweb/ui-components";
import {
    BackButtonContainer,
    BackButtonTextContainer,
} from "app/pages/segments/redesigned-wizard/segment-wizard/styledComponents";

export const BackButton: FunctionComponent<{
    backButtonText: string;
    onClickBack: VoidFunction;
}> = ({ backButtonText, onClickBack }) => (
    <BackButtonContainer>
        <IconButton
            type={"flat"}
            iconName={"arrow-left"}
            onClick={onClickBack}
        >
            <BackButtonTextContainer>{backButtonText}</BackButtonTextContainer>
        </IconButton>
    </BackButtonContainer>
);
